<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="vdp-offers">
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="vdpOfferWidgetEnabled">VDP Offer Widget
          <i class="pi pi-info-circle"
             pTooltip="When enabled, MPOP Offer data and CTA will be displayed on dealer VDP pages when the data is matched by VIN."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-inputSwitch
          id="vdpOfferWidgetEnabled"
          formControlName="vdpOfferWidgetEnabled">
        </p-inputSwitch>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="offerTextColor">Offer Text Color
          <i class="pi pi-info-circle"
             pTooltip="Color used for the standard VDP payment text in the offer widget."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <div class="offer-text-color-control">
          <input id="offerTextColor"
                 type="color"
                 formControlName="offerTextColor"
                 class="offer-text-color-swatch" />
          <input
            type="text"
            class="offer-text-color-hex"
            [value]="form?.get('offerTextColor')?.value"
            (input)="form?.get('offerTextColor')?.setValue($any($event.target).value); form?.get('offerTextColor')?.markAsDirty()"
          />
        </div>
      </div>
    </div>
  </div>
</form>
